import { render, staticRenderFns } from "./edit-order.vue?vue&type=template&id=593ae55f&scoped=true"
import script from "./edit-order.vue?vue&type=script&lang=js"
export * from "./edit-order.vue?vue&type=script&lang=js"
import style0 from "./edit-order.vue?vue&type=style&index=0&id=593ae55f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ae55f",
  null
  
)

export default component.exports